import React, { useState, useRef } from 'react';
import { Grid, Box, Button, Paper, Stack, Typography, Tabs, Tab } from '@mui/material';
import { Add } from '@mui/icons-material';
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { Receipt } from '@mui/icons-material';
import '../../App.css'
import TDSConfigurationTable from '../table-data/TDSConfigurationTable';
import IncomeTaxRulesTable from '../table-data/IncomeTaxRulesTable';
import AddTDSConfigurationForm from './AddTDSConfigurationForm';
import AddIncomeTaxRulesForm from './AddIncomeTaxRulesForm';
import Popup from '../Popup';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      id={`tds-income-tax-tabpanel-${index}`}
      aria-labelledby={`tds-income-tax-tab-${index}`}
      style={{ display: value === index ? 'block' : 'none' }}
      {...other}
    >
      <Box sx={{ pt: 3 }}>
        {children}
      </Box>
    </div>
  );
}

function TDS_Configuration_Combined() {
    const [openPopup, setOpenPopup] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const [popupTitle, setPopupTitle] = useState('');
    const [popupContent, setPopupContent] = useState(null);
    const tdsTableRef = useRef(null);
    const incomeTaxRulesTableRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleCloseModal = () => {
        setOpenPopup(false);
        setPopupContent(null);
    };

    const handleRefresh = () => {
        // Trigger table refresh based on active tab
        if (activeTab === 0) {
            if (tdsTableRef.current && tdsTableRef.current.refreshTable) {
                tdsTableRef.current.refreshTable();
            }
            setRefreshKey(prev => prev + 1);
        } else {
            if (incomeTaxRulesTableRef.current && incomeTaxRulesTableRef.current.refreshTable) {
                incomeTaxRulesTableRef.current.refreshTable();
            }
            setRefreshKey(prev => prev + 1);
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleAddTDS = () => {
        setPopupTitle('Add TDS Configuration');
        setPopupContent(
            <AddTDSConfigurationForm 
                onCloseModal={handleCloseModal}
                setOpenPopup={setOpenPopup}
                onRefresh={handleRefresh}
            />
        );
        setOpenPopup(true);
    };

    const handleAddIncomeTaxRule = () => {
        setPopupTitle('Add Income Tax Rule');
        setPopupContent(
            <AddIncomeTaxRulesForm 
                onCloseModal={handleCloseModal}
                setOpenPopup={setOpenPopup}
                onRefresh={handleRefresh}
            />
        );
        setOpenPopup(true);
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px" }}>
            <Paper elevation={5} sx={{ width: "61%", maxWidth: "1400px" }}>
                <Grid className="form-title" style={{ marginBottom: "-60px" }} container spacing={2}>
                    <Grid item>
                        <Typography variant="h5" sx={{ textAlign: "center", margin: 5, display: "flex", alignItems: "center", gap: 1 }}>
                            <HiOutlineCurrencyRupee size={45} />
                            TDS Configuration for New Regime
                        </Typography>
                    </Grid>
                </Grid>
                <form autoComplete="off" onSubmit={handleSubmit}>
                    <Stack spacing={2} sx={{ margin: "33px" }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                            <Tabs 
                                value={activeTab} 
                                onChange={handleTabChange} 
                                aria-label="TDS and Income Tax Rules tabs"
                                sx={{
                                    '& .MuiTab-root': {
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.95rem',
                                        minHeight: 64,
                                        color: '#6c757d',
                                        '&:hover': {
                                            color: '#0b418e',
                                            background: 'rgba(102, 126, 234, 0.08)'
                                        },
                                        '&.Mui-selected': {
                                            color: '#0b418e',
                                            fontWeight: 700
                                        }
                                    },
                                    '& .MuiTabs-indicator': {
                                        height: 4,
                                        borderRadius: '4px 4px 0 0',
                                        background: 'linear-gradient(90deg, #0b418e 0%, #083a6d 100%)'
                                    }
                                }}
                            >
                                <Tab label="Tax Slabs" />
                                <Tab label="CESS and Rebate" />
                            </Tabs>
                        </Box>

                        <TabPanel value={activeTab} index={0}>
                            <Stack display="flex" sx={{ alignItems: "flex-end", marginRight: "30px" , marginTop: "-44px" }}>
                                <Button
                                    style={{ width: "200px", marginRight: "60px" }}
                                    className="form-btn"
                                    variant="outlined"
                                    color="success"
                                    onClick={handleAddTDS}
                                    startIcon={<Add sx={{ width: "24px", height: "24px" }} />}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        textTransform: "none"
                                    }}
                                >
                                    Add TDS Configuration
                                </Button>
                            </Stack>
                            <TDSConfigurationTable ref={tdsTableRef} refreshKey={refreshKey} />
                        </TabPanel>

                        <TabPanel value={activeTab} index={1}>
                            <Stack display="flex" sx={{ alignItems: "flex-end", marginRight: "30px" }}>
                                <Button
                                    style={{ width: "200px", marginRight: "60px" }}
                                    className="form-btn"
                                    variant="outlined"
                                    color="success"
                                    onClick={handleAddIncomeTaxRule}
                                    startIcon={<Add sx={{ width: "24px", height: "24px" }} />}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        textTransform: "none"
                                    }}
                                >
                                    Add Income Tax Rule
                                </Button>
                            </Stack>
                            <IncomeTaxRulesTable ref={incomeTaxRulesTableRef} refreshKey={refreshKey} />
                        </TabPanel>
                    </Stack>
                </form>

                <Popup
                    title={popupTitle}
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                >
                    {popupContent}
                </Popup>
            </Paper>
        </Box>
    );
}

export default TDS_Configuration_Combined;

